import { Routes } from '@angular/router';
import { UnauthorizedComponent } from '@shared/pages/unauthorized/unauthorized.component';
import { PageNotFoundComponent } from '@shared/pages/page-not-found/page-not-found.component';
import { AuthGuard } from './shared/components/guards/auth.guard';

export const routes: Routes = [
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: 'not-found', component: PageNotFoundComponent },
  {
    path: '',
    loadChildren: () => import('./features/home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.module').then((m) => m.AuthModule),
  },

  {
    path: 'student',
   // canActivate: [AuthGuard],
    loadChildren: () => import('./features/student/student.module').then((m) => m.StudentModule),
  },

  {
    path: 'organization',
    //canActivate: [AuthGuard],
    loadChildren: () =>
      import('./features/organization/organization.module').then((m) => m.OrganizationModule),
  },

  {
    path: 'school',
    //canActivate: [AuthGuard],
    loadChildren: () => import('./features/school/school.module').then((m) => m.SchoolModule),
  },

  {
    path: 'fee',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/fee/fee.module').then((m) => m.FeeModule),
  },

  {
    path: 'in-app-support',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/support/support.module').then((m) => m.SupportModule),
  },

  { path: '**', redirectTo: 'not-found' },
];
